import React from "react";
import { Title } from "../../router";
import { CiMedal } from "react-icons/ci";
import { GiBarbedStar } from "react-icons/gi";
import { BsCashCoin } from "react-icons/bs";
import { MdDashboard, MdOutlineCategory } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { HiOutlineUsers } from "react-icons/hi2";

export const Dashboard = () => {
  const role = "admin";
  return (
    <>
      <section>
        <div className="p-8 mb-12 rounded-lg shadow-s1">
          <Title level={5} className="font-normal ">
            My Activity
          </Title>
          <hr className="my-5" />

          <div className="grid grid-cols-3 gap-8 mt-8">
            <div className="flex flex-col items-center justify-center gap-5 p-8 text-center border shadow-s3 border-green bg-green_100 rounded-xl">
              <BsCashCoin size={80} className="text-green" />
              <div>
                <Title level={1}>500 </Title>
                <Title>Balance</Title>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center gap-5 p-8 text-center border shadow-s3 border-green bg-green_100 rounded-xl">
              <CiMedal size={80} className="text-green" />
              <div>
                <Title level={1}>2</Title>
                <Title>Items Won</Title>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center gap-5 p-8 text-center border shadow-s3 border-green bg-green_100 rounded-xl">
              <GiBarbedStar size={80} className="text-green" />
              <div>
                <Title level={1}>100</Title>
                <Title>Your Products </Title>
              </div>
            </div>
            {role === "admin" && (
              <>
                <div className="flex flex-col items-center justify-center gap-5 p-8 text-center border shadow-s3 border-green bg-green_100 rounded-xl">
                  <MdOutlineCategory size={80} className="text-green" />
                  <div>
                    <Title level={1}>50</Title>
                    <Title>All Products </Title>
                  </div>
                </div>
                <div className="flex flex-col items-center justify-center gap-5 p-8 text-center border shadow-s3 border-green bg-green_100 rounded-xl">
                  <HiOutlineUsers size={80} className="text-green" />
                  <div>
                    <Title level={1}>100</Title>
                    <Title>All Contents </Title>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export const UserProduct = () => {
  return (
    <>
      <div className="p-8 rounded-lg shadow-s1">
        <Title level={5} className="font-normal ">
          Purchasing
        </Title>
        <hr className="my-5" />
        <div className="relative overflow-x-auto rounded-lg">
          <table className="w-full text-sm text-left text-gray-500 rtl:text-right">
            <thead className="text-xs text-gray-700 uppercase bg-gray-100">
              <tr>
                <th scope="col" className="px-6 py-5">
                  Title
                </th>
                <th scope="col" className="px-6 py-3">
                  Bidding ID
                </th>
                <th scope="col" className="px-6 py-3">
                  Bid Amount(USD)
                </th>
                <th scope="col" className="px-6 py-3">
                  Image
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-white border-b hover:bg-gray-50">
                <td className="px-6 py-4">Auction Title 01</td>
                <td className="px-6 py-4">Bidding_HvO253gT</td>
                <td className="px-6 py-4">1222.8955</td>
                <td className="px-6 py-4">
                  <img className="w-10 h-10" src="https://bidout-react.vercel.app/images/bg/order1.png" alt="Jeseimage" />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center">
                    <div className="h-2.5 w-2.5 rounded-full bg-green me-2"></div> Success
                  </div>
                </td>
                <td className="px-6 py-4 text-center">
                  <NavLink to="#" type="button" className="font-medium text-green">
                    <MdDashboard size={25} />
                  </NavLink>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
